import React from 'react';
import { connect } from 'react-redux';
import { hashHistory } from 'react-router';
import { Box, Typography } from '@mui/material';

import SkeletonWrapper from '../../NewProductList/components/SkeletonWrapper/SkeletonWrapper';
import PartnersTable from '../../Partners/components/PartnersTable/PartnersTable';
import AddPartner from '../../Partners/components/AddPartner';
import ButtonInc from '../../../shared-ui/ButtonInc';
import AlertDialog from '../../../components/AlertDialog/index.es6';

import {
  getAllPartnersRequest,
  createPartnerRequest,
  resetCreatePartnerSuccess,
  resetCreatePartnerError,
  getCountriesRequest,
  getLanguagesRequest,
} from '../../Partners/actions.es6';
import { setCurrentPartner } from '../../Main/actions.es6';
import { getPartners, hasAuthourity } from '../../../lib/access.es6';
import { reloadPage } from '../../../lib/utils.es6';

class PartnersTab extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openAddPartnerDialog: false,
      noAccessToPartnerAlert: false,
    };
  }

  componentWillMount() {
    this.props.dispatch(getAllPartnersRequest());

    if (hasAuthourity('CREATE_PARTNER')) {
      if (!this.props.countryData.countries || !this.props.countryData.countries.length) {
        this.props.dispatch(getCountriesRequest());
      }
      if (!this.props.languagesData.languages || !this.props.languagesData.languages.length) {
        this.props.dispatch(getLanguagesRequest());
      }
    }
  }

  addPartner(payload) {
    payload.organization_guid = this.props.organizationGuid;
    this.props.dispatch(createPartnerRequest(payload));
  }

  refreshPartners() {
    this.props.dispatch(getAllPartnersRequest());
  }

  hasAccessToPartner(partnerGuid) {
    var partners = getPartners() || [];
    for (var i = 0; i < partners.length; i++) {
      if (partners[i].guid === partnerGuid) return true;
    }
    return false;
  }

  viewPartner(partner) {
    if (this.hasAccessToPartner(partner.guid)) {
      this.props.dispatch(setCurrentPartner(partner));
      hashHistory.push('admin/partners/view/partner');
      reloadPage();
    } else {
      this.setState({ noAccessToPartnerAlert: true });
    }
  }

  render() {
    var partnersState = this.props.partners;
    var organizationGuid = this.props.organizationGuid;

    if (partnersState.loader) return <SkeletonWrapper loading={true} />;

    var allPartners = partnersState.partners || [];
    var filtered = allPartners.filter(function(p) {
      return p.organization_guid === organizationGuid;
    });

    return (
      <div>
        <Box sx={{
          display: 'flex', justifyContent: 'space-between',
          alignItems: 'flex-start', mb: 3,
        }}>
          <Box>
            <Typography variant="h6" sx={{
              fontWeight: 700, fontSize: 16, color: '#111827',
            }}>
              Partners
            </Typography>
            <Typography variant="body2" sx={{
              fontSize: 13, color: '#6B7280', mt: 0.25,
            }}>
              {filtered.length} partner{filtered.length !== 1 ? 's' : ''} in this organization
            </Typography>
          </Box>
          {hasAuthourity('CREATE_PARTNER') && (
            <ButtonInc variant="contained" color="primary"
              onClick={function() {
                this.setState({ openAddPartnerDialog: true });
              }.bind(this)}>
              + Add Partner
            </ButtonInc>
          )}
        </Box>

        <PartnersTable
          partners={filtered}
          viewPartner={this.viewPartner.bind(this)}
        />

        <AddPartner
          openAddPartnerDialog={this.state.openAddPartnerDialog}
          closeAddPartnerDialog={() => this.setState({ openAddPartnerDialog: false })}
          addPartner={this.addPartner.bind(this)}
          showAddPartnerProgressAlert={partnersState.createPartnerLoader}
          showAddPartnerSuccessAlert={partnersState.createPartnerSuccess}
          showAddPartnerErrorAlert={!!partnersState.createPartnerError}
          createPartnerError={partnersState.createPartnerError}
          resetAddPartnerSuccessAlert={() => this.props.dispatch(resetCreatePartnerSuccess())}
          resetAddPartnerErrorAlert={() => this.props.dispatch(resetCreatePartnerError())}
          refreshPartners={this.refreshPartners.bind(this)}
          countries={this.props.countryData.countries}
          languages={this.props.languagesData.languages}
        />

        <AlertDialog
          warning
          show={this.state.noAccessToPartnerAlert}
          title={'You have no access to this partner'}
          onConfirm={() => this.setState({ noAccessToPartnerAlert: false })}
          confirmBtnText={'ok'}
          showCancel={false}
          confirmBtnCssClass
          style={{ marginTop: '0', top: '30vh' }}
          size="sm"
        >
          <p>Request access to this partner before viewing its details.</p>
        </AlertDialog>
        </div>
    );
  }
}

export default connect(function(state) {
  return {
    partners: state.partners,
    countryData: state.country,
    languagesData: state.languages,
  };
})(PartnersTab);
